import { IPPVEventConfigResponse } from '../../../entity';
import { IUserRegistrationRepository } from '../../repositories/interfaces/iUserRegistrationRepository';
import { container } from '../../../DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IGetPPVEventConfigUseCase {
    execute(): Promise<IPPVEventConfigResponse['data']>;
}

export class GetPPVEventConfigUseCase implements IGetPPVEventConfigUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRegistrationRepo(): IUserRegistrationRepository {
        return container.resolve<IUserRegistrationRepository>(DI.REPOSITORIES.IUserRegistrationRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(): Promise<IPPVEventConfigResponse['data']> {
        const response = await this.userRegistrationRepo.getPPVEventConfig();
        return response?.data;
    }
}
